import {
    Backdrop,
    Box,
    Button,
    CircularProgress,
    FormControl,
    IconButton,
    MenuItem,
    Select,
    Typography,
    useMediaQuery,
    useTheme,
  } from "@mui/material";
  import React, { useEffect, useRef, useState } from "react";
  import Grid from "@mui/material/Grid";
  import SelectComponent from "../../components/SelectComponent/SelectComponent";
  import lang from "../../assets/lang.png";
  import { useDispatch, useSelector } from "react-redux";
  import {
    setIsBackToHoreca,
    setLanguageID,
    updateDefaultLanguage,
  } from "../../store/slice/Ticketing.slice";
  import { useLocation, useNavigate, useParams } from "react-router-dom";
  import CloseIcon from "@mui/icons-material/Close";
  import CheckBoxIcon from "@mui/icons-material/CheckBox";
  import dayjs from "dayjs";
  import Time from "./Time";
  import BookNowFormTicket from "./BookNowFormTicket";
  import EventComponent from "./Event";
  import CalendarTicket from "./CalenderTicket";
  import MultipleEventCalaenderView from "./MultipleEventCalaenderView";
  import EventOrStandardReservationType from "./EventOrStandardReservationType";

const Widget = ({handleClose}) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));
    const {
      totalCount,
      EventDates,
      selectedDate,
      reservType,
      defaultLanguage,
      languageWords,
      isOpenWidget,
      SelectedEventOrStdResType
    } = useSelector((store) => store.Ticketing);
  
    const {
      key,
      widgetConfig,
      languageData,
      resType,
      widgetSetupId
    } = useSelector((store) => store?.widgetSettings);
    const location = useLocation();
    const navigate = useNavigate();
    const { isBookNowOpen } = useSelector((store) => store.addGuest);
    const dispatch = useDispatch();
    const [reservTypeLoading, setReserveTypeLoading] = useState(false);
    const [isEventOpen, setIsEventOpen] = useState(false);
    const eventRef = useRef(null);
    const dateRef = useRef(null);
    const reservationType = useRef(null);
    const timeRef = useRef(null);
    const [isDateDropdownOpen, setIsDateDropdownOpen] = useState(false);
    const [isReservationType, setIsReservationType] = useState(false);
    const [isTimeComponent, setIsTimeComponent] = useState(false);
    const [openWidget, setOpenWidget] = useState(
      location?.state?.openWidgetScreen ?? isOpenWidget
    );
   
    const handleLanguageChange = (event) => {
      const selectedLangCode = event.target.value;
      const selectedLanguage = languageData?.find(
        (item) => item.langcode === selectedLangCode
      );
      dispatch(setIsBackToHoreca(false));
      dispatch(updateDefaultLanguage(selectedLanguage?.langcode));
      dispatch(setLanguageID(selectedLanguage?.idlanguage));
      localStorage.setItem(
        "widget",
        JSON.stringify({
          id: widgetSetupId,
          key: key,
          lang: selectedLanguage?.langcode,
          resType:resType
        })
      );
    };
  return (
    <Box
    className="test"
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: isSmallScreen ? "flex-start" : "flex-end",
      position: "absolute",
      width: "100%",
      top:0,
      backgroundColor: theme.widget?.mainBg,

      height: isSmallScreen || isMediumScreen ? "100%" : "auto",
      zIndex: 1000,
    }}
  >
    <Box
      sx={{
        width: "100%",
        maxWidth: "1567px",
        padding: { xs: 2, sm: 3 },
        height: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Box>
          <Typography sx={{ fontWeight: "bold", fontSize: "1.2rem" }}>
            {languageWords?.BuyTickets || "Make your Reservations"}
          </Typography>
        </Box>

       
          <Box
            sx={{
              display: "flex",
              gap: "1rem",
              mr: isSmallScreen || isMediumScreen ? "1rem" : "12rem",

              alignItems: "center",
            }}
          >
          {languageData?.length > 1 && (   <FormControl
              variant="outlined"
              sx={{
                minWidth: 120,
                backgroundColor: theme?.widget?.langBgColor,
                width: { xs: "100px", md: "120px" },
                height: "45px",
                borderRadius: "5px",
                border: `1px solid ${theme?.widget?.inputBorderColor}`,
              }}
            >
              <Select
                value={defaultLanguage}
                onChange={handleLanguageChange} // Set the onChange handler here
                // IconComponent={() => (
                //     <KeyboardArrowDownIcon
                //         sx={{ color: "black", mr: 1 }}
                //     />
                // )}
                displayEmpty
                renderValue={() => (
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={lang}
                      alt={"lang-img"}
                      style={{ width: "40px", marginRight: "10px" }}
                    />
                  </Box>
                )}
                sx={{
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                  "& .MuiOutlinedInput-input": {
                    padding: 1,
                    //     color: "#9F9F9F",
                    fontSize: "12px",
                  },
                }}
              >
                {languageData?.map((item, index) => (
                  <MenuItem
                    key={item?.idlanguage}
                    value={item?.langcode}
                    sx={{
                      color: theme?.palette?.widget?.langTextColor, // Text color of MenuItem
                      "&.Mui-selected": {
                        backgroundColor:
                          theme?.widget?.langActiveBgColor, // Highlight selected item
                      },
                      "&:hover": {
                        backgroundColor: theme?.widget?.langBgHover, // Hover effect for MenuItem
                        color: theme?.widget?.langTextHover,
                        "&.Mui-selected": {
                          backgroundColor: theme?.widget?.langBgHover, // Hover effect for MenuItem
                          color: theme?.widget?.langTextHover,
                        },
                      },
                    }}
                  >
                    {(item?.langcode == defaultLanguage?.trim()) !=
                    "" ? (
                      <>
                        {item?.language}
                        <CheckBoxIcon
                          sx={{
                            color: theme?.widget?.langCheckboxActive,
                            marginRight: "8px",
                            ml: 2,
                          }}
                        />
                      </>
                    ) : (
                      item?.language
                    )}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
                )}
           {widgetConfig?.settings?.floatButtonActive   && <IconButton
              aria-label="closeIcon"
              size="large"
              onClick={() => handleClose()}
              sx={{
                backgroundColor: theme?.widgetButton?.closeBg,

                "&:hover": {
                  backgroundColor: theme?.widgetButton?.closeHover,
                },
              }}
            >
              <CloseIcon
                sx={{
                  color: theme?.widgetButton?.closeText,
                  "&:hover": {
                    color: theme?.widgetButton?.textcloseTextHover,
                  },
                }}
              />
            </IconButton>}
          </Box>
    
      </Box>

      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <SelectComponent
            label={"Event"}
            value={reservType?.eventTicketName || "Ticket"}
            onClick={() => setIsEventOpen(!isEventOpen)}
            ref={eventRef}
            // disabled={totalCount > 0 ? false : true}
            sx={{
              position: "relative",

              width: "100%",
              height: "72px",
              "& .MuiOutlinedInput-notchedOutline": {
                border: `1px solid ${theme?.widget?.inputBorderColor}`,
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: `1px solid ${theme?.widget?.inputBorderColor}`,
              },
              "& .MuiOutlinedInput-input": {
                padding: 1,
                color: theme?.guest?.textColor,
                ml: 3,
                mt: 1,
                fontSize: { sm: "12px", md: "14px" },
              },
            }}
          />
          <EventComponent
            isOpen={isEventOpen}
            handleClose={() => setIsEventOpen(false)}
            Ref={eventRef.current}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={2}>
          <SelectComponent
            label={languageWords?.date}
            value={
             Object?.keys(reservType)?.length > 0 ? (reservType?.isStandardTicket ? selectedDate : selectedDate?.availableDate) : 'DD-MM-YYYY'
            }
            onClick={() => setIsDateDropdownOpen(!isDateDropdownOpen)}
            ref={dateRef}
            // disabled={Object?.keys(reservType) ? false : true}
            //disabled={totalCount > 0 ? false : true}
            sx={{
              position: "relative",

              width: "100%",
              height: "72px",
              "& .MuiOutlinedInput-notchedOutline": {
                border: `1px solid ${theme?.widget?.inputBorderColor}`,
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: `1px solid ${theme?.widget?.inputBorderColor}`,
              },
              "& .MuiOutlinedInput-input": {
                padding: 1,
                color: theme?.guest?.textColor,
                ml: 3,
                mt: 1,
                fontSize: { sm: "12px", md: "14px" },
              },
            }}
            disabled={Object?.keys(reservType)?.length == 0 || (!reservType?.isStandardTicket && EventDates?.length == 1)}
          />
          {reservType?.isStandardTicket ? (
            <CalendarTicket
              isOpen={isDateDropdownOpen}
              handleClose={() => setIsDateDropdownOpen(false)}
              Ref={dateRef.current}
            />
          ) : (
            <MultipleEventCalaenderView
              isOpen={isDateDropdownOpen}
              handleClose={() => setIsDateDropdownOpen(false)}
              Ref={dateRef.current}
            />
          )}
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={2}>
          <SelectComponent
           label={languageWords?.reserveType}
            value={
              SelectedEventOrStdResType &&
              typeof SelectedEventOrStdResType === "object" &&
              Object.keys(SelectedEventOrStdResType).length > 0
                ? SelectedEventOrStdResType?.name
                : "Type"
            }
            onClick={() => {
              setIsReservationType(!isReservationType);
            }}
            ref={reservationType}
            disabled={selectedDate?.availableDate?.trim() != "" ? false : true}
            sx={{
              position: "relative",

              width: "100%",
              height: "72px",
              "& .MuiOutlinedInput-notchedOutline": {
                border: `1px solid ${theme?.widget?.inputBorderColor}`,
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: `1px solid ${theme?.widget?.inputBorderColor}`,
              },
              "& .MuiOutlinedInput-input": {
                padding: 1,
                color: theme?.guest?.textColor,
                ml: 3,
                mt: 1,
                fontSize: { sm: "12px", md: "14px" },
              },
            }}
          />
          <EventOrStandardReservationType
            isOpen={isReservationType}
            handleClose={() => setIsReservationType(false)}
            Ref={reservationType.current}
            isLoading={reservTypeLoading}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={2}>
          <SelectComponent
            label={languageWords?.Time}
            value={
            Object(reservType)?.keys?.length > 0 || selectedDate  ? (reservType?.isStandardTicket ? reservType?.eventDateAndTime :  `${dayjs(selectedDate?.fromTime, "HH:mm:ss").format("HH:mm")}- ${dayjs(selectedDate?.toTime, "HH:mm:ss").format("HH:mm")}` ) : 'HH:MM'
            }
            onClick={() => setIsTimeComponent(!isTimeComponent)}
            ref={timeRef}
            sx={{
              position: "relative",

              width: "100%",
              height: "72px",
              "& .MuiOutlinedInput-notchedOutline": {
                border: `1px solid ${theme?.widget?.inputBorderColor}`,
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: `1px solid ${theme?.widget?.inputBorderColor}`,
              },
              "& .MuiOutlinedInput-input": {
                padding: 1,
                color: theme?.guest?.textColor,
                ml: 3,
                mt: 1,
                fontSize: { sm: "12px", md: "14px" },
              },
            }}
            disabled={true}
          />
          <Time
            isOpen={isTimeComponent}
            handleClose={() => setIsTimeComponent(false)}
            Ref={timeRef.current}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <Button
            variant="contained"
            fullWidth
            sx={{
              height: "70px",
              backgroundColor:
                reservType &&
                typeof reservType === "object" &&
                Object.keys(reservType).length > 0 &&
                totalCount > 0 &&
                selectedDate 
                  ? theme?.widget?.bookNowbtnBgActive
                  : theme?.widget?.bookNowBtnBg,
              color:
                reservType &&
                typeof reservType === "object" &&
                Object.keys(reservType).length > 0 &&
                totalCount > 0 &&
                selectedDate
                  ? theme?.widget?.booknowBtnTextColorActive
                  : theme?.widget?.booknowBtnTextColor,
              fontWeight: "bold",
              display: "flex", // Ensure flexbox is used
              flexDirection: "column", // Align content in a column (Book Now on top, €25,00 below)
              justifyContent: "center", // Center the text vertically
              alignItems: "center", // Center the text horizontally
            }}
            onClick={() => {
              if (
                reservType &&
                typeof reservType === "object" &&
                Object.keys(reservType).length > 0 &&
                totalCount > 0 &&
                selectedDate 
              ) {
                navigate(`/bookNowTickets`);
              } else {
                return;
              }
            }}
          >
            {languageWords?.Booknow}
            {reservType?.totalCost > 0 &&
              totalCount < widgetConfig?.reservationRequestMin && (
                <Box
                  component="span"
                  fontSize="13px"
                  fontWeight="200"
                >
                  €{parseFloat(reservType?.totalCost).toFixed(2)}
                </Box>
              )}
          </Button>
        </Grid>
      </Grid>

      {isBookNowOpen && <BookNowFormTicket />}
    </Box>
  </Box>
  )
}

export default Widget
